export interface SotGa4MappingRow {
  campaign_key: string;
  ingested_seg_id: string;
  pg_seg_id: string;
  platform_id: string;
  channel_id: string;
  source: string;
  raw_source: string;
  raw_medium: string;
  campaign_name: string;
  campaign_id: string;
  ad_group_name: string;
  ad_group_id: string;
  ad_name: string;
  ad_id: string;
  channel: string;
  platform: string;
  [key: string]: string;
}

export interface SotGa4RowEdit {
  channel?: { label: string; value: string };
  platform?: { label: string; value: string };
  [key: string]: { label: string; value: string } | undefined;
}

export interface SotGa4Row {
  ad_group_id?: string;
  ad_group_name?: string;
  ad_id?: string;
  ad_name?: string;
  campaign_id?: string;
  campaign_name?: string;
  source_of_truth?: string;
  channel?: string;
  platform?: string;
  raw_medium?: string;
  raw_source?: string;
  edits?: SotGa4RowEdit;
  campaign_key: string;
}

export type SotGa4EditsMap = Record<string, SotGa4Row>;

export const SotGa4EditsMapActionType = {
  UPDATE_SEGMENT_EDIT: 'UPDATE_SEGMENT_EDIT',
  DELETE_SEGMENT_EDIT: 'DELETE_SEGMENT_EDIT',
  RESET: 'RESET'
} as const;
export type SotGa4EditsMapActionTypeValue =
  (typeof SotGa4EditsMapActionType)[keyof typeof SotGa4EditsMapActionType];

export interface SotGa4EditsMapAction {
  type: SotGa4EditsMapActionTypeValue;
  updates?: { rows: SotGa4Row[]; edits: SotGa4RowEdit }[];
  campaign_keys?: string[];
  segmentName?: string;
}

export const SotGa4BatchType = {
  LABELED: 'labeled',
  UNLABELED: 'unlabeled'
} as const;
export type SotGa4BatchTypeValue = (typeof SotGa4BatchType)[keyof typeof SotGa4BatchType];
